<template>
  <main class="flex-item">
    <div class="card">
      <header class="card-header page-title">
        <p class="card-header-title is-size-4"><span class="material-icons is-size-4">done</span>更新手続き完了</p>
      </header>
      <div class="card-content">
        <div class="field">
          <p class="block mt-3 mb-5 py-3 has-text-weight-bold">更新手続きが完了いたしました。</p>
        </div>
        <div class="card-content" v-if="isConveni">
          <div class="field">
            <div class="card mb-5">
              <header class="card-header card-title">
                <p class="card-header-title is-size-4"><span class="material-icons accent-color">update</span>コンビニ決済を選択されたお客様へ</p>
              </header>
              <div class="card-content has-text-left">
                <p class="has-text-centered mb-3">以下の内容でお支払いください。</p>
                <label class="label">ご指定のコンビニエンスストア</label>
                <p class="mb-3">{{ getConveniText(conveniCode ?? "") }}</p>

                <!-- コンビニごとに表示が異なる -->
                <!-- セブンイレブン -->
                <template v-if="conveniCode === constants.CONVENIENCE_STORE.SEVEN_ELEVEN">
                  <label class="label">払込票番号</label>
                  <p class="mb-3">{{ conveniRecipt }}</p>
                  <label class="label">お支払期限</label>
                  <p class="mb-3">{{ conveniPayTerm }}</p>
                  <label class="label">払込票等ＵＲＬ</label>
                  <a class="mb-3" :href="conveniReciptUrl">{{ conveniReciptUrl }}</a>
                </template>

                <!-- ファミリーマート -->
                <template v-if="conveniCode === constants.CONVENIENCE_STORE.FAMILY_MART">
                  <label class="label">第1番号（企業コード）</label>
                  <p class="mb-3">{{ conveniConf }}</p>
                  <label class="label">第2番号（注文番号）</label>
                  <p class="mb-3">{{ conveniRecipt }}</p>
                  <label class="label">お支払期限</label>
                  <p class="mb-3">{{ conveniPayTerm }}</p>
                </template>

                <!-- ローソン -->
                <template v-if="conveniCode === constants.CONVENIENCE_STORE.LAWSON">
                  <label class="label">お客様番号</label>
                  <p class="mb-3">{{ conveniRecipt }}</p>
                  <label class="label">確認番号</label>
                  <p class="mb-3">{{ conveniConf }}</p>
                  <label class="label">お支払期限</label>
                  <p class="mb-3">{{ conveniPayTerm }}</p>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div class="card-content" v-if="isConveni">
          <div class="field">
            <h2 class="is-size-4 has-text-weight-bold has-text-left mb-4">【お支払いに関するご注意】</h2>
            <p class="has-text-weight-bold has-text-left mb-2 primary-color">
              コンビニ決済利用期限までお支払いは可能ですが、必ず満期日までにはお支払いください。
            </p>
            <p class="has-text-left mb-4">
              満期日を過ぎてお支払いされた場合は、お支払いされた日が保険契約の開始日となります。<span class="primary-color"
                >その際は、満期日から開始日までの間は更新手続きが未完了のため、万が一事故があった際に保険金のお支払いができませんのでご注意ください。</span
              >
            </p>
          </div>
        </div>

        <footer class="card-footer">
          <div class="card-footer-item">
            <span>
              <router-link :to="{ name: 'Top' }" class="card-footer-item button is-primary is-normal is-medium">契約一覧に戻る</router-link>
            </span>
          </div>
        </footer>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import router from "@/router";
import { MutationTypes, useStore } from "@/store";
import { defineComponent } from "vue";
import { getConveniText } from "common/src/utils/codes";
import constants from "common/src/constants";

export default defineComponent({
  setup() {
    const store = useStore();

    if (store.state.renewal === undefined) {
      router.push({ name: "Renewal" });
    } else if (store.state.renewal.rnw01p.tfReconv === "") {
      router.push({ name: "Payment" });
    }

    // コンビニ払いの場合のみ表示する情報を取得
    // 直接入金などが増える可能性があるので、表示制御を一応入れている
    const isConveni = store.state.conveni !== undefined;
    const conveniCode = store.state.conveni?.tfReconv;
    const conveniConf = store.state.conveni?.tfRecono;
    const conveniRecipt = store.state.conveni?.tfRereno;
    const conveniPayTerm = store.state.conveni?.tfRepydt;
    const conveniReciptUrl = store.state.conveni?.receiptUrl;

    // ストアの更新データ・コンビニデータをリセット
    store.commit(MutationTypes.RESET_RENEWAL);

    return {
      isConveni,
      conveniCode,
      conveniConf,
      conveniRecipt,
      conveniPayTerm,
      conveniReciptUrl,
      constants,
      getConveniText,
    };
  },
});
</script>
